import React from "react";
import "./LoanAssistance.css";

const LoanAssistance = () => {
  const benefits = [
    {
      icon: "percent",
      title: "Competitive Interest Rates",
      desc: "Starting from 8.5% per annum with special schemes for aviation students",
    },
    {
      icon: "rupee-sign",
      title: "Flexible Repayment",
      desc: "Moratorium period during training plus 7–10 years repayment tenure",
    },
    {
      icon: "shield-alt",
      title: "No Collateral Required",
      desc: "Loans up to ₹40 lakhs without collateral for eligible candidates",
    },
  ];

  return (
    <section className="loan-section">
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT SIDE */}
          <div className="col-md-6">
            <h2 className="loan-title">
              Loan Assistance for Pilot Training
            </h2>

            <p className="loan-subtitle">
              We partner with leading banks to provide easy education loans
              covering up to 100% of training costs with flexible repayment options
            </p>

            {benefits.map((item, i) => (
              <div key={i} className="loan-item">
                <div className="loan-icon">
                  <i className={`fas fa-${item.icon}`}></i>
                </div>

                <div className="loan-text">
                  <h5>{item.title}</h5>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT SIDE IMAGE */}
          <div className="col-md-6 text-end">
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/loan.jpg`}
              alt="Loan assistance"
              className="loan-image"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default LoanAssistance;
